import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import styled, { ThemeProps, withTheme } from "styled-components";

const Container = styled.div`
  width: 100%;
`;

const IconsWrapper = styled(NavLink)`
  color: ${(props) => props.theme.darkGreyColor};
  display: flex;
  flex-direction: column;
  padding: 0.8rem;
  cursor: pointer;
  :hover {
    color: ${(props) => props.theme.primaryColor};
  }
  @media (max-width: ${(props) => props.theme.maxWidth}) {
    flex-direction: column;
    justify-content: space-around;
    padding: 0.5rem;
    padding-bottom: 1rem;
  }
`;

const NonLink = styled.div`
  color: ${(props) => props.theme.darkGreyColor};
  display: flex;
  flex-direction: column;
  cursor: pointer;
  padding: 0.8rem;
  :hover {
    color: ${(props) => props.theme.primaryColor};
  }
  @media (max-width: ${(props) => props.theme.maxWidth}) {
    flex-direction: column;
    justify-content: space-around;
    padding: 0.5rem;
    padding-bottom: 1rem;
  }
`;

const Text = styled.p`
  font-size: 1rem;
`;

const Description = styled.p`
  ${(props) => props.theme.description};
  font-size: 0.7rem;
  line-height: 1.6;
`;

const Items = styled.div`
  width: 100%;
  border-radius: 0.5rem;
  margin-top: 0.5rem;
  background-color: ${(props) => props.theme.lightGreyColor};
  padding: 0.5rem;
`;

interface IProps extends ThemeProps<any> {
  title: any;
  path: any;
  items: any;
  description: any;
  exact: any;
}
const AdminMenuItem: React.SFC<IProps> = ({
  title,
  path,
  items = [],
  description = "",
  exact = false,
  theme,
}) => {
  const [showItems, setShowItems] = useState(false);
  const activeStyle = {
    color: theme.primaryColor,
  };

  const toggleItems = () => {
    setShowItems(!showItems);
  };
  return (
    <Container>
      {items.length > 0 ? (
        <NonLink onClick={toggleItems}>
          <Text>{title}</Text>
          <Description>{description}</Description>
          {showItems && (
            <Items>
              {items.map((item, index) => (
                <AdminMenuItem
                  key={index}
                  title={item.name}
                  path={item.path}
                  items={item.items}
                  description={item.description}
                  exact={item.exact}
                  theme={theme}
                />
              ))}
            </Items>
          )}
        </NonLink>
      ) : (
        <IconsWrapper activeStyle={activeStyle} exact={exact} to={path}>
          <Text>{title}</Text>
          <Description>{description}</Description>
        </IconsWrapper>
      )}
    </Container>
  );
};

export default withTheme(AdminMenuItem);
